import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private apiUrl = `${environment.apiUrl}/appconfig`;

  constructor(private http: HttpClient) {}

  getSports(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>(`${this.apiUrl}/sports`);
  }

  getMinVersion(): Observable<ApiResponse<{ version: string }>> {
    return this.http.get<ApiResponse<{ version: string }>>(`${this.apiUrl}/min-version`);
  }
}
